import { LabelFilter } from "../components/translation/statistics/TranslationStats";
import { Label } from "../model/Label";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export interface FetchTranslationExportsParams {
  translationId: number;
  filter: LabelFilter;
}

export type TranslationMode = "edit" | "review";

export const fetchTranslationLabels = async (
  { translationId, filter }: FetchTranslationExportsParams,
  mode: TranslationMode
): Promise<Label[]> => {
    const apiStartTime = performance.now(); 
    console.log(`API CALL START`);
    const response =  await axiosInstance.get<ApiResponse<Label[]>>(
    `/api/translation/phase/${translationId}/${mode}-labels?filter=${filter}`
  );
    const apiTime = performance.now() - apiStartTime;
    console.log(`API DONE: ${response.data.data?.length || 0} rows in ${apiTime.toFixed(0)}ms`);

  return response.data.data || [];

};
